import "./Dashboard.scss";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import {
  ADMIN_ROLES,
  API_RESPONSE,
  DASHBOARD,
  I18_TRANSLATION_COMMON,
  LANGUAGES,
  LAYOUTS,
  NUMBER_CONSTANTS,
  STORAGE_KEYS,
} from "../../../Utilities/Constants/Constants";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import HC_exporting from "highcharts/modules/exporting";
import downloadCSV from "highcharts/modules/export-data";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Card } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import sessionImg from "../../../../Assets/Dashboard/dashboard_session.svg";
import availableSlotsImg from "../../../../Assets/Dashboard/available_slots.svg";
import averageRatingImg from "../../../../Assets/Dashboard/Average_Rating.svg";
import cancelledSlotsImg from "../../../../Assets/Dashboard/cancelled_slots.svg";
import completedSlotsImg from "../../../../Assets/Dashboard/completed_slots.svg";
import ongoingSlotsImg from "../../../../Assets/Dashboard/ongoing_slots.svg";
import totalStudentsImg from "../../../../Assets/Dashboard/Tot_Students.svg";
import totalBookedSlots from "../../../../Assets/Dashboard/Total_booked_slots.svg";
import totalSlotsImg from "../../../../Assets/Dashboard/Total_Slots.svg";
import upcomingSlotsImg from "../../../../Assets/Dashboard/upcoming_slots.svg";
import paymentReceived from "../../../../Assets/Dashboard/payment_received.svg";
import completedSummary from "../../../../Assets/Dashboard/summary_completed.svg"
import { GetSessionStorageData } from "../../../Services/Helpers/Helper";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';


const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState<any>({});
  const [roleId, setRoleId] = useState<any>("");
  /*Initial API calls**/
  useEffect(() => {
    setRoleId(GetSessionStorageData(STORAGE_KEYS.ROLE));
    getDashboardData();
    getCoverData();
  }, []);
  /* Translation hook**/
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [coverData, setCoverData] = useState<any>({});
  /* get language from redux**/
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  /* Getting dashboard data API call */
  const getDashboardData = () => {
    let userType = GetSessionStorageData(STORAGE_KEYS.ROLE) === ADMIN_ROLES.TUTOR ? `${NUMBER_CONSTANTS.ONE}` : ADMIN_ROLES.RECREATIONAL_PERSONAL ? `${NUMBER_CONSTANTS.TWO}` : `${NUMBER_CONSTANTS.THREE}`;
    axiosInstance.get(API_END_POINTS.DASHBOARD + "?type=" + userType).then((response) => {
      setDashboardData(response.data.result.data);
    });
  };

  /* Getting user cover data */
  const getCoverData = () => {
    axiosInstance.get(API_END_POINTS.COVER_IMAGE).then((response) => {
      setCoverData(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
    });
  }

  const barState: any = {
    chart: {
      type: "column",
    },
    title: {
      text: "Payments Received",
    },
    subtitle: {
      text: "",
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Amount in AED",
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f} AED</b></td></tr>',
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    exporting: {
      enabled: true,
      menuItemDefinitions: {
        // Custom definition
        viewFullscreen: {
          text: "fullscreen",
        },
      },
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            {
              text: "DownloadXLSX",
              onclick() {
                // this.downloadXLSX();
              },
            },
            {
              text: "DownloadCSV",
              onclick() {
                // this.getCSV();
              },
            },
          ],
        },
      },
    },
    series: [
      {
        name: "Payment",
        color: roleId === ADMIN_ROLES.TUTOR ? '#178FFF' : '#e88818',
        data: [
          49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1,
          95.6, 54.4,
        ],
      },

    ],
  };

  const chartOptions = {
    chart: {
      type: 'pie',
      marginBottom: 100
    },
    title: {
      text: 'Slots',
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false, // Disable data labels (values inside slices)
        },
        connectorWidth: 0, // Disable connectors (arrow markers)
      },
    },
    series: [
      {
        name: 'Slots',
        data: [
          ['Booked Slots', dashboardData?.booked_slots],
          ['Available Slots', dashboardData?.unbooked_slots],
          ['Cancelled Slots', dashboardData?.completed_slots],
        ],

        showInLegend: true
      },
    ],
    exporting: {
      enabled: true,
      menuItemDefinitions: {
        // Custom definition
        viewFullscreen: {
          text: "fullscreen",
        },
      },
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            {
              text: "DownloadXLSX",
              onclick() {
                // this.downloadXLSX();
              },
            },
            {
              text: "DownloadCSV",
              onclick() {
                // this.getCSV();
              },
            },
          ],
        },
      },
    },
  };

  return (
    <div className="dashboard-wrapper">
      <div className="row">
        <div className="col-md-8">
          <div className="data-wrapper">
            <div className="first-card-wrapper">
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={sessionImg} />
                </div>

                <h4 className="dash-count">{dashboardData?.sessions}</h4>
                <p>TOTAL SESSIONS</p>
              </Card>
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={totalSlotsImg} />
                </div>

                <h4 className="dash-count">{dashboardData?.slots}</h4>
                <p>TOTAL SLOTS</p>
              </Card>
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={totalBookedSlots} />
                </div>
                <h4 className="dash-count">{dashboardData?.booked_slots}</h4>
                <p>TOTAL BOOKED SLOTS</p>
              </Card>
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={completedSlotsImg} />
                </div>
                <h4 className="dash-count">{dashboardData?.completed_slots}</h4>
                <p>TOTAL COMPLETED SLOTS</p>
              </Card>
            </div>

            <div className="first-card-wrapper">
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={ongoingSlotsImg} />
                </div>

                <h4 className="dash-count">{dashboardData?.unbooked_slots}</h4>
                <p>TOTAL UNBOOKED SLOT</p>
              </Card>
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={upcomingSlotsImg} />
                </div>

                <h4 className="dash-count">{dashboardData?.upcoming_slots}</h4>
                <p>TOTAL UPCOMING SLOTS</p>
              </Card>
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={availableSlotsImg} />
                </div>
                <h4 className="dash-count">{dashboardData?.unbooked_slots}</h4>
                <p>TOTAL AVAILABLE SLOTS</p>
              </Card>
              <Card className="main-card">
                <div className="dash-icon-wrapper">
                  <img className="icons" src={cancelledSlotsImg} />
                </div>
                <h4 className="dash-count">{dashboardData?.completed_slots}</h4>
                <p>TOTAL CANCELLED SLOTS</p>
              </Card>
            </div>

            <div className="row">
              <div className="col-md-7">
                <div className="second-card-wrapper">
                  <Card className="secondary-card">
                    <div className="secondary-card-content">
                      <div className="dash-icon-wrapper">
                        <img className="icons" src={totalStudentsImg} />
                      </div>

                      <div>
                        <p>TOTAL STUDENTS</p>
                        <h4 className="dash-count">{dashboardData?.students_count}</h4>
                      </div>


                    </div>
                    <div className="secondary-card-content">
                      <div className="dash-icon-wrapper">
                        <img className="icons" src={averageRatingImg} />
                      </div>
                      <div>
                        <p>AVERAGE RATING</p>
                        <h4 className="dash-count">{dashboardData?.avg_rating ? dashboardData?.avg_rating?.toFixed(1) : 0}/5</h4>
                      </div>


                    </div>
                  </Card>
                  {/* <Card className="secondary-card">
                   
                  </Card> */}
                </div>
              </div>
              <div className="col-md-5">
                <div className="second-card-wrapper">
                  <Card className="payment-card">
                    <div className="dash-icon-wrapper">
                      <img className="icons" src={paymentReceived} />
                    </div>
                    <div className="payment-card-content">
                      <h4 className="dash-count">3000 <span>AED</span></h4>
                      <p>TOTAL PAYMENTS RECEIVED</p>
                    </div>


                  </Card>
                </div>

              </div>
            </div>

            <div className="pie_bar_chart_container">
              <HighchartsReact
                className="dashboard-highchart"
                highcharts={Highcharts}
                options={barState}
              />
            </div>

          </div>
        </div>
        <div className="col-md-4">
          <Card className="dashboard-profile-wrapper">
            <div className="profile-wrapper">
              <div className="image-content">
                <img src={coverData?.profile} className="profile-image" />
                <div>
                  <p className="sp-name">{coverData?.name}</p>
                  <div className="type-btn">
                    <p>{roleId === ADMIN_ROLES.TUTOR ? 'Tutor' : ADMIN_ROLES.RECREATIONAL_CAMP ? 'RECREATIONAL CAMP' : 'RECREATIONAL TRAINER'}</p>
                  </div>
                </div>
              </div>

            </div>

            <div className="week-summary-container">
              <p className="week-text">Month Summary</p>

              <Card className="summary-card">
                <div className="icon-div">
                  <img src={completedSummary} className="icon-img" />
                </div>
                <div className="summary-data">
                  <p className="heading">Completed Sessions</p>
                  <p className="count-data">5</p>
                </div>
              </Card>
              <Card className="summary-card">
                <div className="icon-div">
                  <img src={paymentReceived} className="icon-img" />
                </div>
                <div className="summary-data">
                  <p className="heading">Payment Received</p>
                  <p className="count-data">1500 <span className="currency">AED</span></p>
                </div>
              </Card>

            </div>

            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </Card>




        </div>
      </div>
    </div>
  );
};

export default Dashboard;
